import { Button, Flex } from "antd";
import RequestTable from "./RequestTable";
import { FilterIcon } from "../../assets";
import ButtonSwitch from "../../components/ButtonSwitch";
import { Popup } from "../../components";
import FilterForm from "../../forms/FilterForm";
import { usePopup } from "../../hooks/usePopup";
import AppliedFilter from "../../forms/AppliedFilter";
import RequestUserTable from "./RequestUserTable";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getAtcState, getExamState } from "../../redux/store/getState";
import { getAtc } from "../../redux/apiActions/atcActions";
import Select from "../../components/Select";
import { getExams } from "../../redux/apiActions/examActions";

const buttons = ["ATC Admin", "Public Users"];

export default function Requests() {
  const popup = usePopup();
  const dispatch = useAppDispatch();

  const [activeButton, setActiveBtn] = useState<string | null>(null);

  const { atc, loading } = useAppSelector(getAtcState);
  const { exams, loading: examLoading } = useAppSelector(getExamState);

  useEffect(() => {
    dispatch(getAtc());
    dispatch(getExams());
  }, [dispatch]);

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <ButtonSwitch
          buttons={buttons}
          onSwitch={(activeButton: string) => setActiveBtn(activeButton)}
        />
        <Popup
          ref={popup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm
            popup={popup}
            extraFormItem={
              <>
                <div
                  className="full-width-divider"
                  style={{ marginBottom: 20 }}
                />
                {activeButton === "Public Users" ? (
                  <Select
                    options={exams}
                    loading={examLoading.getExam}
                    placeholder={"Select Exam"}
                    formItemProps={{
                      name: "atc_id",
                      label: "Select Exam",
                      rules: [{ required: true, message: "Exam is required" }],
                    }}
                  />
                ) : (
                  <Select
                    options={atc}
                    loading={loading.getAtc}
                    formItemProps={{
                      label: "ATC",
                      name: "atc_id",
                      rules: [{ required: true, message: "ATC is required" }],
                    }}
                    placeholder="Select ATC"
                  />
                )}
              </>
            }
          />
        </Popup>
        <AppliedFilter />
      </Flex>
      {activeButton === "Public Users" ? (
        <RequestUserTable />
      ) : (
        <RequestTable />
      )}
    </>
  );
}
